import { EMAIL_REGEX } from '../constants';

const isValidEmail = (email: string) => {
  return EMAIL_REGEX.test(email);
};

export default isValidEmail;
